module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAgCAMAAABJuvqBAAAAXVBMVEUAAABveZBweI9wd5BxepJ5gJpweJBweJBvd5Bvd5Bwd5BweI9weJB2e5Rwd49wd5BweJFweJFyepOJiZtvd5Bvd5BweJBvd5BweJBweJJzepNveJBwd5BweZFvd48e+JNJAAAAHnRSTlMAZ5mrNAySdfbhycNiFu26WkseB/Dn159/PiXRiFPWYfpHAAAA2ElEQVQ4y9WRSRKDIBRE24jgFOchmoT7HzP6kWgFEbZ5u656Wt0fLLCA36zwgGHlHkoH4R1AKp2kLYT0QCDz0VJwD2uogdk1oQ9ATFcr4lcETZXYrLEBwUluRXcmZYyceoDsREtX5mfNV1gpJZaYVACMLYVq3oxrgLrLpLY8f5tHj5gi9LvNJObJFhsV+zWQpuHb593efP85DmX0lve3uaERiRJIHuURmIfSze0aldfN7RqR0VpDM/kzrfCxCpQ+WonKR6uA0G2FWBDxtRQLEBHLAys5i+DNB3TzbVgQWlwwAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/_icon-email.png
// module id = yTg1
// module chunks = 0